import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import type { ReactElement } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { router, sentryCreateBrowserRouter } from 'routes/main';

import { DEFAULT_LANGUAGE } from 'constants/general';
import AppLocale from 'languages';

import AppProviders from './AppProviders';
import AppTheme from './AppTheme';
import { store } from './store';

const App = (): ReactElement => {
  const defaultLang = AppLocale[DEFAULT_LANGUAGE];

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <IntlProvider
          locale={defaultLang.locale}
          defaultLocale={defaultLang.locale}
          messages={defaultLang.messages}
        >
          <AppTheme>
            <RouterProvider router={sentryCreateBrowserRouter(router)} />
            <AppProviders />
            <ToastContainer
              position="top-right"
              autoClose={15000}
              closeOnClick
              pauseOnHover
              hideProgressBar
              transition={Slide}
            />
          </AppTheme>
        </IntlProvider>
      </LocalizationProvider>
    </Provider>
  );
};

export default App;
